import image1 from "../assets/t-image1.png";
import image2 from "../assets/t-image2.jpg";
import image3 from "../assets/t-image3.jpg";

export const testimonialsData = [
	{
		image: image1,
		review: "I made the right choice by choosing the Fitclub and by choosing the right plan and program I already achieved my ideal body!",
		name: "MATHEW HENDRICKSON",
		status: "ENTREPRENEUR",
	},
	{
		image: image2,
		review:
			"With regular exercise, I have lost weight and my body composition has continued to improve. I find The Fit Club's workout very fun, so I don't feel bored exercising.",
		name: "JOHN KEVIN",
		status: "CUSTOMER",
	},
	{
		image: image3,
		review:
			"From time to time doing exercises at The Fit Club, I feel a change in my life. My body gradually felt better. I have become much fitter, healthier, and the most amazing thing is that I have become a much happier person.",
		name: "FRANKLIN",
		status: "EMPLOYEE",
	},
];
